module.exports = __webpack_public_path__ + "media/application/images/svgs/meh-1372108226550e2432b75fc4c43c6789.svg";